const teamMembers = [
    {
        iconSrc: "../images/demitra.png",
        iconAlt: "demitra",
        personName: "Demitra Selimos",
        position: "Co-President, Founder",
        role: "1st Year Medicine"
    },
    {
        iconSrc: "../images/ria_sinha.png",
        iconAlt: "ria-sinha",
        personName: "Ria Sinha",
        position: "Co-President",
        role: "3rd Year Cellular, Molecular and Microbial Biology"
    },
    {
        iconSrc: "../images/gulroob.png",
        iconAlt: "gulroob",
        personName: "Gulroob Saini",
        position: "VP Finance",
        role: "3rd Year Organizational Behaviour and Human Resources"
    },
        {
        iconSrc: "../images/hooriya_icon.png",
        iconAlt: "hooriya",
        personName: "Hooriya Khan",
        position: "VP IT",
        role: "4th Year Software Engineering"
    },
    {
        iconSrc: "../images/basema.png",
        iconAlt: "basema",
        personName: "Basema Khan",
        position: "VP IT",
        role: "3rd Year Software Engineering"
    },
    {
        iconSrc: "../images/abby.png",
        iconAlt: "abby",
        personName: "Abby Hutchison",
        position: "VP Events",
        role: "3rd Year Nursing"
    },
    {
        iconSrc: "../images/brittney.png",
        iconAlt: "brittney",
        personName: "Brittney Dunn",
        position: "VP Internal",
        role: "4th Year Community Rehabilitation and Disability Studies"
    },
    {
        iconSrc: "../images/ria_sharma.png",
        iconAlt: "ria-sharma",
        personName: "Ria Sharma",
        position: "VP Marketing",
        role: "4th Year Neuroscience"
    },
    {
        iconSrc: "../images/jasnoor.png",
        iconAlt: "jasnoor",
        personName: "Jasnoor Chauhan",
        position: "VP Marketing",
        role: "3rd Year Health Sciences"
    },
    {
        iconSrc: "../images/sherri.png",
        iconAlt: "sherri",
        personName: "Sherri Hunyh",
        position: "VP External",
        role: "4th Year Bio Science"
    },
    {
        iconSrc: "../images/eliza.png",
        iconAlt: "eliza",
        personName: "Eliza Khan",
        position: "VP External",
        role: "2nd Year Health Sciences"
    },
];

export default teamMembers;
